/** Ensure external URLs open off-site (e.g. `www.example.com` → `https://www.example.com`). */
export function normalizeExternalUrl(url: string | null | undefined): string {
  const trimmed = (url ?? '').trim();
  if (!trimmed || trimmed === '#') {
    return '';
  }
  if (/^(https?:\/\/|mailto:|tel:)/i.test(trimmed)) {
    return trimmed;
  }
  return `https://${trimmed}`;
}
